import * as Default from '../default';
// import * as Env from './env/-APP_ENV_TARGET/config.js';

/* Last Release / Update */
export const RELEASE_DATE = `05/05/25`;
export const RELEASE_VERSION = '0.8.9.12';
export const YOUDJ_CORE_VERSION = 'v29.92';

/* App */
export const APP_NAME = `beatsource`;
export const API_NAME = `beatsource`;

/* Auth */
export const ACRONYME = `bsrc`;
export const API_URL = `https://api.beatsource.com/v4`;
export const API_CLIENT_ID = Default.API_CLIENT_ID;
export const API_SEARCH_URL = Default.API_SEARCH_URL;
export const API_IDENTITY_URL = Default.API_IDENTITY_URL;
export const API_DJAPP_URL = 'https://dj.beatport.com/api';
export const AUTH_DJAPP_URL = `https://dj.beatport.com/api/custom/bp/v2`; // `/custom/bsrc/v2`; // new Identity System - `/custom/bsrc`; //v1
/* 8YxHwCn3ZhDCo2yZneKidSsTXKVUQgmzl4WWXTcN => not supported the new Identity System */

export const PARTNERS = ` Pioneer DJ, Serato DJ, Denon DJ, Traktor Pro, Hercules, Djay and more.`;
export const REDIRECT_FORGOT_PASSWORD = `https://www.beatsource.com/account/forgot-password`;

/* Colors */
export const TYPE_LIGHT = Default.TYPE_LIGHT;
export const TYPE_SECONDARY = Default.TYPE_SECONDARY;
export const TYPE_PLACEHOLDER = Default.TYPE_PLACEHOLDER;
export const TYPE_DARK_SECONDARY = Default.TYPE_DARK_SECONDARY;
export const TYPE_DISABLE = Default.TYPE_DISABLE;
export const BRAND_PRIMARY = `#188BFF`;
export const BRAND_SECONDARY = Default.BRAND_SECONDARY;
export const BRAND_TERTIARY = `#FFF500`;
export const GREY_1 = Default.GREY_1;
export const GREY_2 = Default.GREY_2;
export const BLACK_2 = Default.BLACK_2;
export const BLACK_3 = Default.BLACK_3;
export const BLACK_5 = Default.BLACK_5;
export const SYSTEM_BLACK_2 = Default.SYSTEM_BLACK_2;

/* Covers */
export const OLD_IMG = Default.OLD_IMG;
export const DEFAULT_IMG = 'https://dj.beatsource.com/picx/vinyl_default1.png';
export const DEFAULT_AVATAR = Default.DEFAULT_AVATAR;
export const DEFAULT_LABEL = Default.DEFAULT_LABEL;

/* Library */
export const MAX_WIDTH = Default.MAX_WIDTH;
export const MAX_HEIGHT_PLAYER = Default.MAX_HEIGHT_PLAYER;

export const TAB_BAR_HEIGHT = Default.TAB_BAR_HEIGHT;
export const TAB_BAR_GUTTER = Default.TAB_BAR_GUTTER;

export const RECENT_TRACKS_LIMIT = 250;

export const LEFT_MENU_CUSTOM_HEIGHT = 100;

export const LEFT_PAD_TOP = Default.LEFT_PAD_TOP;
export const CONTENT_PAD = Default.CONTENT_PAD;
export const SIDE_WIDTH = Default.SIDE_WIDTH;
export const SIDE_WIDTH_CLOSE = Default.SIDE_WIDTH_CLOSE;
export const CARD_WIDTH = Default.CARD_WIDTH;
export const CARD_HEIGHT = Default.CARD_HEIGHT;
export const CARD_PAD = Default.CARD_PAD;
export const GRID_PAD = Default.GRID_PAD;
export const SUB_SIDEBAR = Default.SUB_SIDEBAR;
export const GRID_WIDTH = Default.GRID_WIDTH;

export const CHART_PAD = Default.CHART_PAD;
export const CHART_IMAGE_SIZE = Default.CHART_IMAGE_SIZE;
export const FILTERS_PAD = Default.FILTERS_PAD;

export const LIST_ROW_HEIGHT = Default.LIST_ROW_HEIGHT;
export const GUTTER_PREVIEW = Default.GUTTER_PREVIEW;

export const GRID_ROW_HEIGHT = Default.GRID_ROW_HEIGHT;

export const GRID_TREND_ROWS = Default.GRID_TREND_ROWS;
export const GRID_TREND_COLUMNS = Default.GRID_TREND_COLUMNS;
export const GRID_TREND_HEIGHT = Default.GRID_TREND_HEIGHT;

export const GRID_TREND_GENRE_ROWS = Default.GRID_TREND_GENRE_ROWS;
export const GRID_TREND_GENRE_COLUMNS = Default.GRID_TREND_GENRE_COLUMNS;
export const GRID_TREND_GENRE_HEIGHT = Default.GRID_TREND_GENRE_HEIGHT;

export const ARTIST_GRID_WIDTH = Default.ARTIST_GRID_WIDTH;
export const ARTIST_COLUMNS_MAX = Default.ARTIST_COLUMNS_MAX;

export const PLAYLIST_COVER_SIZE = Default.PLAYLIST_COVER_SIZE;
export const DNAV_COVER_SIZE = Default.DNAV_COVER_SIZE;
export const MENU_COVER_SIZE = Default.MENU_COVER_SIZE;
export const TREND_COVER_SIZE = Default.TREND_COVER_SIZE;
export const ARTIST_LABEL_COVER_RELEASE = Default.ARTIST_LABEL_COVER_RELEASE;

export const GRID_COVER_PAD = Default.GRID_COVER_PAD;
export const GRID_COVER_SIZE = Default.GRID_COVER_SIZE;

export const LC_LEFT_PAD = Default.LC_LEFT_PAD;
export const LC_PAD_BETWEEN = Default.LC_PAD_BETWEEN;

export const STICKY_HEADER_HEIGHT = Default.STICKY_HEADER_HEIGHT;

/* MODULES */
export const MOD_TOOLTIPS = Default.MOD_TOOLTIPS;
export const MOD_LINKAGE = Default.MOD_LINKAGE;
export const MOD_PRO = true;
export const MOD_FEEDBACK = true;
/* Party Mode */
export const PARTYMODE = true;
export const PM_URL = 'https://dj.beatsource.com';
export const PM_PATH = '/partymode/';
export const PM_MAX_ACTIVES = Default.PM_MAX_ACTIVES;
/* NOTES / NEWS */
export const MOD_NOTES = false;
/* Iframe - Post Message */
export const IFRAME = Default.IFRAME;
/* Freemium */
export const FREEMIUM = Default.FREEMIUM;
/* Welcome Onboarding */
export const ONBOARDING = true;
/* POPUPS */
export const POPUPS = false;
/* Automix */
export const AUTOMIX_ALL = false;

export const REDIRECT_TRIAL = 'https://www.beatsource.com/subscriptions?utm_medium=referral&utm_source=dj_web_app&utm_campaign=evergreen';

/* FOOTER */
export const F_ABOUT_US = `https://about.beatport.com/`;
export const F_CONTACT = `https://support.beatport.com/hc/en-us/articles/4412288252308-Contact-Information`;
export const F_CAREERS = 'https://about.beatport.com/careers/';
export const F_IMAGES = 'https://support.beatport.com/hc/en-us/articles/4412316336404-Beatport-Logos-and-Images';
export const F_COPYRIGHT = `https://form.jotform.com/92474857521970`;
export const F_SUPPORT = `https://support.beatsource.com/hc/en-us/articles/360032946792-Contact-our-Support-Team`;
export const F_POLICY = `https://support.beatsource.com/hc/en-us/articles/4413209937684`;
export const F_FEEDBACK = null;
export const F_FEEDBACK_GUEST = null;
export const F_LEGAL = Default.F_LEGAL;
export const F_REDIRECT_NAME = `Beatport DJ`;
export const F_REDIRECT_URL = `https://dj.beatport.com/`;
export const F_TERMS = `https://support.beatsource.com/hc/en-us/articles/4413195884692`;
export const F_FAQ = null;
export const F_FAQ_HARDWARE = null;
export const F_RELEASE_NOTES = null;

/* SOCIALS */
export const S_FACEBOOK = `https://www.facebook.com/beatsource`;
export const S_TWITTER = `https://twitter.com/beatsource`;
export const S_INSTAGRAM = `https://www.instagram.com/beatsourceofficial`;
export const S_YOUTUBE = `https://www.youtube.com/channel/UCnbLAh_q-PD5DaZ8ekARxQA`;
export const S_TWITCH = `https://www.twitch.com/beatsource`;
export const S_TIKTOK = `https://www.tiktok.com/@beatsource`;
export const S_DISCORD = `https://discord.gg/ezBmCaCknd`;

/* FUNC / OPTIONS */
export const LIMIT_STRING_CAPITALIZE = false;
export const TRENDS_ARTIST_LABEL_MORE = true;
export const GENRES_HAS_FAV = false;
export const GENRES_HAS_CUSTOM_EMPTY = false;
export const ACCESS_STORE = false;
export const HAS_FILTER_EXCLUDE = false;

/* LIST */
export const SHOW_MIX_NAME = false;
export const LIST_HEADER_HAS_REMIXER = false;
export const LIST_HAS_MORE = Default.LIST_HAS_MORE;
export const LIST_NAME_WIDTH = `80%`;

/* GENRES */
export const GENRES_HAS_TRENDING_LABELS = true;
export const GENRES_PLAYLISTS_HAS_FILTERS = false;
export const GENRES_CUSTOM_EXTRA_SEARCH_SLUG = [];
export const GENRES_HAS_HYPE = false;
export const GENRES_HAS_EXCLUSIVE = false;

/* SPLAHSCREEN */
export const HAS_SPLASH = Default.HAS_SPLASH;

/* CART */
export const CART_ENABLE = true;
export const CART_ITEM_TYPE = 6;
export const CART_AUDIO_FORMAT = 1;
export const CART_PURCHASE_TYPE = 1;
export const CART_SOURCE_TYPE = 2;